import { cn } from "@/components/podkit/lib/cn";
import { Text } from "@/components/podkit/typography/Text";
import type { FC, ReactNode } from "react";

export type SuperOnaEmptyStateProps = {
    icon: ReactNode;
    message: string;
    className?: string;
};

export const SuperOnaEmptyState: FC<SuperOnaEmptyStateProps> = ({ icon, message, className }) => {
    return (
        <div className={cn("flex flex-1 flex-col items-center justify-center", className)}>
            <div className="flex flex-col items-center gap-2 text-center">
                {icon}
                <Text className="text-content-tertiary">{message}</Text>
            </div>
        </div>
    );
};
